<div>

  <div style="margin: 15px auto;width:80dw; max-width: 1200px; height: 500px">

    <div style="">
      <img src="/assets/flow-studio-logo-90.png" style="display:block; margin: 0px auto;">
      <h3 style='text-align: center;'>Flow Towards Success</h3>

      <div style="text-align: center;">Your flows are critical to you, your process and your business. We want to help
        you keep them that way.</div>

    </div>
    <div style="display: flex;">
      <div style="width:20%;"></div>
      <div style="width: 60%; padding-right:5px;">

        <h4 style="color: #ff6358;">Company</h4>

        <div>
          Flow Studio Solutions Pty Ltd.<br>
          ABN 82 632 928 539<br>
          PO BOX 115, <br>
          Lidcombe 1825, <br>
          Sydney, Australia<br>
        </div>

        <h4 style="color: #ff6358;">Custom Flow Solutions</h4>
        <div style="">
          In addition to the app, we also offer many <b>custom Microsoft Flow solutions</b>. <br>
          <br>
          We know Office 365 and Microsoft Flow extremely well. We know how to make them really dance. We'll work with
          you to understand your requirements, and will train you so you can understand how the solution is built too! <br>
          Whether you want to build new flows, uprade or support existing flows, troubleshoot or creating flows to
          connect PowerApps. <br>
          We can help migrating your existing workflows from SharePoint (or other workflow systems) to Microsoft Flow. <br>
          We can also help build reports, dashboards or analytics into your flows.<br>
        </div>
        <!-- <h4 style="color: #ff6358;">Custom Flow Training</h4>
        <div style="">
          We offer advanced or customized training in Microsoft Flow and PowerApps. <br>
          <br>
          Nobody likes doing repetitive tasks, your business needs employees that can automate their work.
          We believe in an <b>culture of automation</b> - it is our mission to help you, your power users, developers
          and administrators get over the learning curves and be really successful with Microsoft Flow.<br>
          <br>
          <a href="mailto:support@flowstudio.app">Contact us</a> if you are interested in our custom flow solutions or
          training offerings.<br>
        </div> -->


        <button kendoButton routerLink="/welcome" [icon]="'arrow-left'" look="flat">Back</button>
      </div>

    </div>
    <div style="width:20%;"></div>
  </div>
</div>
